import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-orientacao-portabilidade-sumula-proposta',
  templateUrl: './orientacao-portabilidade-sumula-proposta.component.html',
  styleUrls: ['./orientacao-portabilidade-sumula-proposta.component.scss'],
})
export class OrientacaoPortabilidadeSumulaPropostaComponent implements OnInit {
  @Input() entidadeProposta: string = '';
  @Input() razaoSocialEntidade: string = '';
  @Input() codigoProposta: string = '';
  @Input() vigenciaProposta: string = '';
  @Input() mostrarOrientacaoPortabilidade: boolean = false;
  @Input() mostrarOrientacaoSumula: boolean = false;
  @Input() mostrarHeader: boolean = true;
  @Input() operadoraVM: any;
  @Input() dadosOperadoraCabecalho: any;

  constructor() {}

  ngOnInit(): void {}
}
